module.exports = __webpack_public_path__ + "static/media/closeIcon.7a772f7d.svg";